import React, { Component, useEffect, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import OfferDetailView from './OfferDetailView'
import crmservices from '../../wsclient/';
import { eventTypeSimple, googleAnalytics } from '../../intergrations/google.analytics';
const styles = theme => ({

});
const PAGE_SIZE = 10;
function OfferDetail(props) {
    const [offerItem, setOfferItem] = useState(null);
    const [zoomMap, setZoomMap] = useState(12);
    const [direction, setDirection] = useState(null);
    const [region, setRegion] = useState({
        latitude: 35.157322,
        longitude: 33.313751,
        latitudeDelta: 0.015,
        longitudeDelta: 0.0121,
    });
    const [centerRegion, setCenterRegion] = useState(null);
    const [showLoading, onShowLoading] = useState(false);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [isRunning, setGetLocationStatus] = useState(null);
    const [locationCheckTimer, setLocationCheckTimer] = useState(null);
    const [showDirection, onShowDirection] = useState(null);
    const [showLoadMore, setShowLoadMore] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [venues, setVenues] = useState(null);

    const initialRegion = {
        lat: 35.157322,
        lng: 33.313751,
    };
    useEffect(async () => {
        if (isRunning == 'start') {
            let locationCheckTimer = setInterval(async () => { await getLocation(); }, 500);
            setLocationCheckTimer(locationCheckTimer)
        } else {
            stopCheckingLocation();
        }
        return () => clearInterval(locationCheckTimer);
    }, [isRunning]);

    useEffect(() => {
        getLocation()
        onShowOfferDetail()
    }, []);

    const onShowOfferDetail = async () => {

        const offer = props.offer
        googleAnalytics.sendLogEvents(eventTypeSimple.viewed_offer, { item_id: offer && offer.id ? offer.id : '', contentType: 'offer'});
        //  console.log('onShowOfferDetail offer=== ',offer)
        if (offer && offer.owned_by && offer.owned_by.id) {

            onShowLoading(true);

            try {
                let result = await crmservices.rewards.getOrganisationDetail(offer.owned_by.id);
                // console.log("getOrganisationDetail result:", result);
                if (result.code == 'OK') {
                    offer.phone_number = getContactPhone(result.data.contact_info);
                    offer.industry_name = result.data.industry_name;
                    offer.industry_sectors = result.data.industry_sectors;
                }
                // let locationsResult = await crmservices.rewards.getOrgLocations({lat:currentLocation.lat,lon:currentLocation.lon,distance:5}, offer.owned_by.id);
                //   console.log("locationsResult result:", locationsResult);
                // if (locationsResult.code == 'OK') {
                //     if (locationsResult.data.content && locationsResult.data.content.length > 0) {
                //         offer.venues = locationsResult.data && locationsResult.data.content ? locationsResult.data.content : null;
                //     } else {
                //         if (result.data.locations && result.data.locations.length > 0) {
                //             offer.venues = [{ locations: result.data.locations }];
                //         }
                //     }
                // }
            } catch (error) {
                console.log("get store info exception:", error);
            }
            //console.log("offer Item:", offer);
            onShowLoading(false);
            setOfferItem(offer);
        }

    }
    const onLoadOrganisation = async (currentLocation, page) => {
        let _venues = venues ? [...venues.content] : [];
        console.log("curentlocation",currentLocation);
        console.log('offer====',props.offer)
        let params = {
            sort: "DISTANCE",
            order: "DESC",
            lat: currentLocation.lat,
            lon: currentLocation.lon,
            distance: 5,
            size: PAGE_SIZE,
            page: page ? page : 1,
        };
        let locationsResult = await crmservices.rewards.getOrgLocations(params, props.offer.owned_by.id);
        console.log("location data===",locationsResult)
        if (locationsResult.code == 'OK') {
            _venues = [..._venues, ...locationsResult.data.content];
            setVenues({ paging: locationsResult.data.paging, content: _venues });
            if (locationsResult.data.content.length === 0) setHasMore(false);
        }
        console.log("venue:", _venues);
        setOfferItem(prevState => ({
            ...prevState,
            venues: _venues,
        }));
    }
    const handleLoadMore = async () => {
        console.log("AAAAA handle load more");
        try{
            let paging = venues ? venues.paging : null;
            console.log("paging: ", paging);
            if(paging && paging.size >= PAGE_SIZE && !showLoadMore){
                setShowLoadMore(true);
                let page = paging && paging.page ? paging.page + 1 : 1;
                await onLoadOrganisation(currentLocation, page);
                setShowLoadMore(false);
            }
        }catch(ex){
            console.log("load more org exception: ", ex);
        }
    }
    const stopCheckingLocation = () => {
        setGetLocationStatus('stop');
        if (locationCheckTimer) {
            clearInterval(locationCheckTimer);
        }
    }
    const getContactPhone = (contact_info) => {
        let phone_number = "";
        if (contact_info && contact_info.length > 0) {
            let phones = contact_info.filter(contact => {
                return contact.type === 'PHONE';
            })
            if (phones && phones.length > 0) {
                phone_number = phones[0].value;
            }
        }
        return phone_number;
    }

    const getLocation = async () => {
        setCurrentLocation(initialRegion);
        console.log("getoffetitem:",offerItem)
        await navigator.geolocation.getCurrentPosition(async (location) => {
            var currentLocation = {
                lat: location.coords.latitude,
                lon: location.coords.longitude,
            }
            // console.log("AAAAA location:", location);
            // var currentLocation = {
            //     lat: 35.135402,
            //     lon: 33.333574
            // }
            console.log("AAAAA location:", currentLocation);
            setCurrentLocation(currentLocation);
            await onLoadOrganisation(currentLocation)
        }, (err) => {
            console.log('getLocation err', err);
        }, {
            timeout: 60000,
            enableHighAccuracy: false
        });
    }

    const onSelectMerchant = (merchant) => {
        //console.log(' merchant========', merchant)
        let location = merchant.locations && merchant.locations.length > 0 ? merchant.locations[0] : null;
        if (location.lat && location.lon) {
            onShowDirection(true);
            setDirection(location);
            setCenterRegion(location);
            setZoomMap(12);
        }
    }

    const onDirection = () => {
        if (direction) {
            let url = 'https://www.google.com/maps/search/?api=1';
            if (direction.lat && direction.lon) {
                url = url + '&query=' + direction.lat + "," + direction.lon;
            }
            if (direction.googleplaceid) {
                url = url + '&query_place_id=' + direction.googleplaceid;
            }
            console.log("url:", url);
            window.open(url)
            //Linking.openURL(url);
            // openMap({ end: direction.lat + "," + direction.lon, provider: provider });
        }
    }

    return (
        <div>
            <OfferDetailView
                showLoading={showLoading}
                offer={offerItem}
                onCloseOfferDetail={props.onCloseOfferDetail}
                open={props.open}
                onClose={props.handleDrawerToggle}
                venues={venues}
                centerRegion={centerRegion}
                zoomMap={zoomMap}
                showDirection={showDirection}
                hasMore={hasMore}
                showLoadMore={showLoadMore}
                onDirection={onDirection} 
                handleLoadMore={handleLoadMore}
                onShowOfferDetail={onShowOfferDetail}
                onSelectMerchant={onSelectMerchant}
            />
        </div>
    );
}

export default withStyles(styles)(withTranslation()(OfferDetail));